import React, {Children, cloneElement, isValidElement} from 'react'
import {isArray, pick} from 'lodash'

export const withInheritedProps = (children, props) => {
  let childrenWithProps = children
  if (children) {
    childrenWithProps = Children.map(children, child => {
      if ((child.type && child.type.name === 'Router') || (child.props.primary === true && !child.props.path)) {
        return cloneElement(child, {}, withInheritedProps(child.props.children, props))
      }
      let {inherit} = child.props
      if (inherit) {
        let propsToInherit = props
        if (isArray(inherit)) {
          propsToInherit = pick(props, inherit)
        }
        return cloneElement(child, propsToInherit, withInheritedProps(child.props.children, propsToInherit))
      }
      return child
    })
    // childrenWithProps = cloneElement(childrenWithProps, {...props})
  }
  return childrenWithProps
}

export const withProps = (children, props) => {
  if (!children) {
    return children
  }
  return Children.map(children, child => {
    if (isValidElement(child)) {
      return cloneElement(child, props)
    }
    return child
  })
}